
        require('./index.scss');
        'use strict';

var $ = window.$;
var $mod = $('.module-pagination');

var _module = {
    init: function init() {
        var items = $mod.find('a');

        $mod.on('click', 'a:not(.current):not(.disabled)', function () {
            var item = $(this);
            var index = item.index();

            items.removeClass('current').eq(index).addClass('current');
        });

        // Event.on(function (command) {
        //     if (command === 'hide') {
        //         $mod.hide();
        //     }
        // });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/loupan-common/pagination-new/index.js